import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';
import { BackendService } from '../../../core/backend.service';
import { CONFIG } from '../../../core/config';
import { ExtendedTreeNode } from '../../../shared/dynamic-details-tree/extended-tree-node.model';
import { AssetHierarchyItem } from '../../../viewmodels/hierarchy/asset-hierarchy-item';

interface KeyVal {
  key: string;
  value: string;
}

export interface ReportTreeResponse {
  items: TreeviewResponseValues[];
  selectedIds: Set<string>;
}

export interface TreeviewResponseValues {
  key: KeyVal;
  value: ExtendedTreeNode[];
}

export interface TreeviewResponse {
  values: TreeviewResponseValues[];
  selectedItem: KeyVal;
}


@Injectable({
  providedIn: 'root',
})
export class HierarchyStructureInfoProviderService {
  private inflightTreeviewRequests: Map<string, Observable<TreeviewResponse>> = new Map();
  constructor(private backendService: BackendService) { }

  public obtain(hierarchyItemOrId: AssetHierarchyItem | string): Observable<string> {
    if (hierarchyItemOrId) {
      return this.backendService.getAnyById(
        CONFIG.apiRoutes.hierarchyStructureInfo,
        hierarchyItemOrId instanceof AssetHierarchyItem ? hierarchyItemOrId.orgTreeNodeId : hierarchyItemOrId,
      );
    }

    return of('');
  }

  public obtainItems(itemId: string): Observable<any> {
    return this.backendService.getAnyById(CONFIG.apiRoutes.hierarchyStructureItems, itemId);
  }

  public obtainTreeviewItems(itemId: string, url: string): Observable<TreeviewResponse> {
    if (!itemId) {
      return of({ values: [], selectedItem: null } as TreeviewResponse);
    }

    const key = `${url}|${itemId}`;

    const existing = this.inflightTreeviewRequests.get(key);
    if (existing) {
      return existing;
    }

    const req$ = (this.backendService.getAnyById(url, itemId) as Observable<TreeviewResponse>)
      .pipe(
        finalize(() => this.inflightTreeviewRequests.delete(key)),
        shareReplay(1),
      );

    this.inflightTreeviewRequests.set(key, req$);

    return req$;
  }
}
